// extracted by mini-css-extract-plugin
export default {"widgetIcon":"styles_widgetIcon__Wu7g4"};